export default __webpack_public_path__ + "static/media/kinderGame.63c1772b.png";